import React from "react";
import typographyTokens from "../../styles/tokens/typography";
import { DisplayProps } from "../../types/Typography";

export const Display: React.FC<DisplayProps> = ({
  size = "2xl",
  element = "h1",
  align = "left",
  color,
  truncate = false,
  lineClamp,
  children,
  className = "",
  style = {},
  onClick,
  testID,
  ...rest
}) => {
  const getStyles = (): React.CSSProperties => {
    const tokenSet =
      size === "2xl" ? typographyTokens.display2xl : typographyTokens.displayXl;

    const fontWeightValue = parseInt(tokenSet.fontWeight);

    const baseStyles: React.CSSProperties = {
      fontFamily: tokenSet.fontFamily,
      fontSize: `${tokenSet.fontSize}px`,
      lineHeight: `${tokenSet.lineHeight}px`,
      fontWeight: fontWeightValue,
      color: color || tokenSet.color,
      textAlign: align,
      letterSpacing: tokenSet.letterSpacing,
      textDecoration: tokenSet.textDecoration || "none",
    };

    if (truncate) {
      baseStyles.whiteSpace = "nowrap";
      baseStyles.overflow = "hidden";
      baseStyles.textOverflow = "ellipsis";
      baseStyles.display = "block";
    }

    if (lineClamp && lineClamp > 0) {
      baseStyles.display = "-webkit-box";
      baseStyles.WebkitLineClamp = lineClamp;
      baseStyles.WebkitBoxOrient = "vertical";
      baseStyles.overflow = "hidden";
      baseStyles.textOverflow = "ellipsis";
    }

    return baseStyles;
  };

  const combinedStyles = {
    ...getStyles(),
    ...style,
  };

  const Component = element as React.ElementType;

  return (
    <Component
      style={combinedStyles}
      className={className}
      data-testid={testID}
      onClick={onClick}
      {...rest}
    >
      {children}
    </Component>
  );
};
